import React, { useMemo } from 'react';
import AboutIntroSection from '../components/about/AboutIntroSection';
import AboutHistorySection from '../components/about/AboutHistorySection';
import AboutMissionSection from '../components/about/AboutMissionSection';
import AboutVisionValuesSection from '../components/about/AboutVisionValuesSection';
import AboutBranchesSection from '../components/about/AboutBranchesSection';
import { useData } from '../context/DataContext';
import { mergeAboutDisplayData, mergeBranchesDisplay } from '../utils/aboutLayoutDefaults';
import '../components/about/about.css';

const AboutUsPage = () => {
    const { branches, settings, aboutUs, loading } = useData();

    const displayData = useMemo(() => mergeAboutDisplayData(aboutUs), [aboutUs]);
    const displayBranches = useMemo(() => mergeBranchesDisplay(branches), [branches]);

    return (
        <main className="about-page min-h-screen bg-white">
            <div className="pt-28 pb-2 bg-white">
                <div className="about-shell">
                    <nav className="flex items-center gap-2 text-[13px] font-medium mb-2">
                        <a href="/" className="text-slate-500 hover:text-[#E31E24] transition-colors no-underline">
                            Trang chủ
                        </a>
                        <span className="text-slate-300">/</span>
                        <span className="text-[#1a1a1a] font-bold">Giới thiệu</span>
                    </nav>
                </div>
            </div>

            {loading && !aboutUs ? (
                <div className="flex flex-col items-center justify-center min-h-[40vh] py-20">
                    <div className="w-12 h-12 border-4 border-red-100 border-t-[#E31E24] rounded-full animate-spin mb-4" />
                    <p className="about-caption">Đang tải dữ liệu...</p>
                </div>
            ) : (
                <>
                    <AboutIntroSection data={displayData} />
                    <AboutHistorySection data={displayData} />
                    <AboutMissionSection data={displayData} />
                    <AboutVisionValuesSection data={displayData} />
                    <AboutBranchesSection
                        title={displayData.branchesSectionTitle}
                        branches={displayBranches}
                        settings={settings}
                    />
                </>
            )}
        </main>
    );
};

export default AboutUsPage;
